"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var global_state_1 = require("../../redux/global/global.state");

var scenario_tree_view_component_1 = __importDefault(require("../scenario-tree-view/scenario-tree-view.component"));

var scenario_tree_view_utils_1 = require("../scenario-tree-view/scenario-tree-view.utils");

var overview_content_styles_1 = require("./overview-content.styles");

var OverviewContent = function OverviewContent(_ref) {
  var nodeMap = _ref.nodeMap,
      setCurrentNodeId = _ref.setCurrentNodeId,
      setAppMode = _ref.setAppMode;
  return react_1.default.createElement(overview_content_styles_1.StyledOverviewContentDiv, null, react_1.default.createElement(scenario_tree_view_component_1.default, {
    treeData: scenario_tree_view_utils_1.convertNodeMapToTreeData(nodeMap, scenario_state_1.GREETING_SCENARIO_NODE_ID),
    handleEditClick: function handleEditClick(nodeId) {
      if (!nodeId) return;
      setCurrentNodeId(nodeId);
      setAppMode(global_state_1.AppMode.Editor);
    }
  }));
};

exports.default = OverviewContent;